import { Store } from '@ngxs/store';
import { StoreProvider } from './store.provider';

export const mockErrorHandlerStore = (store: Store): void => {
  const storeProvider = new StoreProvider({ get: () => store });
  storeProvider.init();
};
